import { render } from "./Downlink3.vue?vue&type=template&id=2b57f66e"
import script from "./Downlink3.vue?vue&type=script&lang=js"
export * from "./Downlink3.vue?vue&type=script&lang=js"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__